
// @ts-nocheck


export const localeCodes =  [
  "pt-br",
  "en-us"
]

export const localeLoaders = {
  "pt-br": [
    {
      key: "locale_pt_46js_8f96dc5c",
      load: () => import("#nuxt-i18n/8f96dc5c" /* webpackChunkName: "locale_pt_46js_8f96dc5c" */),
      cache: true
    }
  ],
  "en-us": [
    {
      key: "locale_en_45us_46js_29c27e77",
      load: () => import("#nuxt-i18n/29c27e77" /* webpackChunkName: "locale_en_45us_46js_29c27e77" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "pt-br",
      region: "bra",
      region2: "br",
      language: "pt",
      files: [
        {
          path: "/app/i18n/locales/pt.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en-us",
      region: "usa",
      region2: "us",
      language: "en",
      files: [
        {
          path: "/app/i18n/locales/en-us.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "pt-br",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "pt-br",
    region: "bra",
    region2: "br",
    language: "pt",
    files: [
      {
        path: "/app/i18n/locales/pt.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en-us",
    region: "usa",
    region2: "us",
    language: "en",
    files: [
      {
        path: "/app/i18n/locales/en-us.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/